'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearActivityListeners = exports.setActivityListeners = undefined;

var _pageActivity = require('./pageActivity');

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTIVITY_EVENTS = ['click', 'mouseup', 'mousedown', 'mousewheel', 'keypress', 'keydown', 'keyup', 'resize', 'focus', 'blur'];

var debouncedActivityHandler = (0, _lodash2.default)(_pageActivity.activityHandler, _constants.DEBOUNCE_MS);
var debouncedScrollHandler = (0, _lodash2.default)(_pageActivity.scrollHandler, _constants.DEBOUNCE_MS);

var setActivityListeners = exports.setActivityListeners = function setActivityListeners() {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = ACTIVITY_EVENTS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var event = _step.value;

      addEventListener(event, _pageActivity.activityHandler);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  addEventListener('mousemove', debouncedActivityHandler);
  addEventListener('scroll', debouncedScrollHandler);
};

var clearActivityListeners = exports.clearActivityListeners = function clearActivityListeners() {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = ACTIVITY_EVENTS[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var event = _step2.value;

      removeEventListener(event, _pageActivity.activityHandler);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  removeEventListener('mousemove', debouncedActivityHandler);
  removeEventListener('scroll', debouncedScrollHandler);
};